interface GearInsidePersonSVGProps {
  color: string;
  style: React.CSSProperties;
}

const GearInsidePersonSVG = ({ color, style }: GearInsidePersonSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="52"
    viewBox="0 0 56 52"
    fill="none"
  >
    <g clipPath="url(#clip0_1284_1290)">
      <path
        d="M38.4969 5.14804V8.62608C38.4969 9.64107 38.639 10.6506 38.9179 11.625L39.9395 15.1924C41.2453 19.7585 40.6608 24.6656 38.3146 28.7851L37.6898 29.6648C35.9496 32.1089 36.1615 35.4516 38.1966 37.6521"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.1084 21.0766H47.5057"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.959 21.507C16.4148 22.9225 17.1602 24.2082 18.1255 25.2881L20.7023 24.1784C21.4665 24.8551 22.4747 25.4532 23.3434 25.7212L23.6786 28.528C24.3757 28.6769 25.0997 28.7553 25.8424 28.7553C26.5852 28.7553 27.3091 28.6769 28.0063 28.528L28.3415 25.7212C29.3255 25.3856 30.2184 24.8551 30.9826 24.1784L33.5594 25.2881C34.5247 24.2082 35.2701 22.9225 35.7259 21.507L33.4843 19.8072C33.5808 19.3092 33.6344 18.7949 33.6344 18.2671C33.6344 17.7393 33.5835 17.225 33.4843 16.727L35.7259 15.0273C35.2701 13.6117 34.5247 12.326 33.5594 11.2461L30.9826 12.3558C30.2184 11.6791 29.3255 11.1513 28.3415 10.813L28.0063 8.00623C27.3091 7.85736 26.5852 7.77887 25.8424 7.77887C25.0997 7.77887 24.3355 7.83842 23.6786 8.00623L23.3434 10.813C22.4747 11.1053 21.4665 11.6791 20.7023 12.3558L18.1255 11.2461C17.2836 12.1907 16.6079 13.2896 16.1467 14.4968C16.0796 14.6727 16.018 14.8486 15.959 15.03M25.8451 22.2026C23.692 22.2026 21.9491 20.4405 21.9491 18.2698C21.9491 16.0991 23.6947 14.3371 25.8451 14.3371C27.9956 14.3371 29.7411 16.0991 29.7411 18.2698C29.7411 20.4405 27.9956 22.2026 25.8451 22.2026Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9593 15.0949H10.5832L7.27441 10.9051"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.37554 11.2082C6.73498 11.2082 7.83702 10.0958 7.83702 8.7235C7.83702 7.35124 6.73498 6.2388 5.37554 6.2388C4.0161 6.2388 2.91406 7.35124 2.91406 8.7235C2.91406 10.0958 4.0161 11.2082 5.37554 11.2082Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9583 21.442H10.5822L7.27344 25.6319"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.53723 30.0048C7.73519 29.3561 8.18539 27.8499 7.54278 26.6407C6.90017 25.4314 5.40809 24.977 4.21012 25.6256C3.01216 26.2743 2.56196 27.7805 3.20457 28.9897C3.84718 30.199 5.33926 30.6535 6.53723 30.0048Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.81055 18.2672H18.0509"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.53665 18.8031C5.82891 17.4633 4.98965 16.137 3.66238 15.842C2.33511 15.547 1.02125 16.3941 0.728985 17.7339C0.436718 19.0737 1.27598 20.4 2.60325 20.695C3.93052 20.99 5.24438 20.1428 5.53665 18.8031Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.418 25.2503L14.2118 28.5145C16.1719 32.0791 17.1559 36.0308 17.2819 40.0583C17.3114 41.0138 17.0058 51.3261 17.0058 51.3261"
        stroke={color}
        strokeWidth="1.27244"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.8747 51.3234C39.9122 49.4558 39.9444 46.7031 40.2903 44.4241C40.5289 42.8543 41.8669 41.6985 43.4382 41.6985H47.9643C49.9619 41.6985 51.5841 40.0637 51.5841 38.0446V32.7693C51.5841 32.1333 52.0212 31.5838 52.6352 31.4431L53.6568 31.0263C55.1289 30.6906 55.8073 28.9665 54.9626 27.7025L50.8414 21.5368C50.1979 20.5759 51.0398 18.4268 51.0398 18.4268C51.4393 17.3929 50.7878 14.919 50.4848 13.8012C49.0449 8.48534 45.2052 4.16013 40.0248 2.20052C35.118 0.34376 27.9614 0.433079 24.3094 1.14222C20.2579 1.92985 14.5038 4.19261 11.9082 10.8591"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26 36L26 51"
        stroke={color}
        strokeWidth="1.27244"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1284_1290">
        <rect width="56" height="52" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default GearInsidePersonSVG;
